import React from 'react'
import {SiTailwindcss, SiReact, SiPython, SiHtml5} from 'react-icons/si';
import {DiJavascript1} from 'react-icons/di'
import 'aos/dist/aos.css'

export default function About() {
  return (
    <div className='max-w-xl mt-96 sm:mt-60 2xl:pt-10 mx-auto'>
      <p className='text-white text-3xl font-bold place-content-center flex font-cust'>
          Hey!&nbsp;<img className='w-10 h-10' src='https://raw.githubusercontent.com/MartinHeinz/MartinHeinz/master/wave.gif' alt=''/>
      </p>
      

      <div className='flex mx-auto justify-center h-50 sm:h-55 sm:w-xl my-5 sm:my-7 bg-transparent bg-opacity-10 rounded-2xl shadow-yellow-800 hover:shadow-sky-900 shadow-5xl animate-pulse hover:animate-none'>
        <p className= 'flex text-xs sm:text-xl pl-5 pr-5 mt-2 mb-2 sm:pt-3 sm:pb-3 text-slate-300 justify-center'>
            I'm a Software Engineer who is passionate 
            about learning new Technologies and experimenting with the ideas through them.
            Apart from coding, I also do Web Development and accomplished a few projects with a range of acquired skills for the same.
            Also, I have deployed a variety of websites and applications using different technologies symboled below. Thanks for reading! 
        </p>
      </div>
      <div className='flex flex-wrap justify center pt-3 sm:pt-7'>
          <div data-aos="slide-right" className='flex my-2 sm:my-0 sm:ml-auto mx-auto sm:mr-auto flex-col bg-gradient-to-b from-gray-700 to-gray-900 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden shadow-black shadow-xl rounded-full hover:animate-spin'>
              <SiTailwindcss color='#87CEEB' className='animate-spin sm:animate-none'/>
          </div>

          <div data-aos="fade-up"  className='flex my-2 sm:my-0 mx-auto sm:mr-auto flex-col bg-gradient-to-b from-gray-700 to-gray-900 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden  shadow-black shadow-xl rounded-full hover:animate-spin'>
              <DiJavascript1 color='yellow'/>
          </div>

          <div data-aos="fade-down" className='flex my-2 sm:my-0 mx-auto sm:mr-auto flex-col bg-gradient-to-b from-gray-700 to-gray-900 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden  shadow-black shadow-xl rounded-full hover:animate-spin'>
              <SiReact color='cyan' className='animate-spin sm:animate-none'/>
          </div>
          

          <div data-aos="fade-up" className='flex my-2 sm:my-0 mx-auto sm:mr-auto flex-col bg-gradient-to-b from-gray-700 to-gray-900 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden shadow-black shadow-xl rounded-full hover:animate-spin'>
              <SiHtml5 color='#FF8C00'/>
          </div>

          <div data-aos="slide-left"  className='flex my-2 sm:my-0 mx-auto sm:mr-auto flex-col bg-gradient-to-b from-gray-700 to-gray-900 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden shadow-black shadow-xl rounded-full hover:animate-spin'>
              <SiPython className='hover:text-yellow-500 text-blue-500 animate-spin sm:animate-none'/>
          </div>

          {/*<div className='flex my-2 sm:my-0 mr-2 sm:mr-7 flex-col bg-gray-700 text-2xl sm:text-4xl w-15 sm:w-30 p-3 sm:p-5 overflow-hidden bg-white shadow-black shadow-xl rounded-full hover:animate-spin'>
              <SiFlutter color='cyan' />
          </div>*/}
      </div>
    </div>
  )
}
